import { render, staticRenderFns } from "./TreatmentCompositionTab.vue?vue&type=template&id=b1109fac"
import script from "./TreatmentCompositionTab.vue?vue&type=script&lang=js"
export * from "./TreatmentCompositionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports